import * as React from 'react'
import { css, Rule } from 'glamor'
import * as PropTypes from 'prop-types'

import { useTheme } from '../../theme'

interface IUnreadBadgeProps {
  style?: Rule
  size?: 'small' | 'medium'
}

export function UnreadBadge({ style, size }: IUnreadBadgeProps) {
  const theme = useTheme()
  return (
    <span
      {...css(
        {
          borderRadius: '12px',
          backgroundColor: theme.colors.accents.primary,
          boxShadow: '0 0 0 2px white',
          width: size === 'small' ? '6px' : '12px',
          height: size === 'small' ? '6px' : '12px',
        },
        style
      )}
    />
  )
}

UnreadBadge.propTypes = {
  style: PropTypes.object,
  size: PropTypes.oneOf(['small', 'medium']).isRequired,
}
